module.exports = __webpack_public_path__ + "img/savings.7a072e43.svg";